<cam-badge class="d-flex" [type]="this.type()" [value]="this.label() | translate"></cam-badge>
